<template>
  <div class="wrap">
    <template v-if="!(isPureType && !removePureItem)">
      <div v-if="sizeGroupObj && !isPureType" class="wrap-item">
      <div class="wrap-item_label">{{sizeGroupObj.label}}</div>
      <div class="wrap-item_content">
        <Radio :props="{dataSource: sizeGroupObj, name: sizeGroupObj.name}" :isSizeGroup="true" />
      </div>
      </div>
      <div class="wrap-item">
        <div class="wrap-item_label">商品规格</div>
        <div class="wrap-item_content">
          <RuleSortBtn v-if="!isPureType" class="inline-block" :specifications.sync="specifications" />
          <div v-if="removePureItem" class="inline-block">
            <el-checkbox :value="tjbForm.pureType" :true-label="1" :false-label="0" @change="changePureType">纯商品</el-checkbox>
            <el-tooltip effect="dark" content="勾选后支持纯商品发布，商品规格信息不生效" placement="top">
              <i class="el-icon-question help-icon" />
            </el-tooltip>
          </div>
          <FormItemSpecification
            v-if="!isPureType"
            v-model="specifications"
            remarkKey="note"
            :isPlatform="true"
            :changeToBase="tjbFormVm.changeToBase" />
        </div>
      </div>
      <div v-if="!isPureType" class="wrap-item">
        <div class="wrap-item_label">商品明细</div>
        <div class="wrap-item_content">
          <FormItemSkuList
            :specifications="specifications"
            :baseItemId="tjbFormVm.form.baseItemId"        
            :imgOnlyPreview="skuImgOnlyPreview"
            :tableCols="skuTableCols_all"
            @skuFieldBlur="handleSkuFieldBlur"
            @fieldChanged="specificationsFieldChanged"
            v-model="skuList"/>
          <template v-if="tjbFormVm.specificationsValidResult !== true">
            <div class="el-form-item__error">{{tjbFormVm.specificationsValidResult}}</div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {specification_mixin} from '@/components/prod/center/components/FormItemSpecification'
import storeMixins from '../store-mixins'
import Radio from '../Radio'

import FormItemSpecification from './Specifications/FormItemSpecification.vue'

export default {
  components: {
    Radio,
    FormItemSpecification
  },
  provide: {
    // noSpPic: true,
    disabledSpName: true,
    // disabledSpValue: true,
    platform: "tjb",

  },
  inject: {
    tjbFormVm: 'tjbFormVm',
    skuDeliveryTimeOptions: {
      from: 'skuDeliveryTimeOptions',
      default: ()=> {
        return []
      }
    }
  },
  mixins: [specification_mixin, storeMixins],
  props: ["props"],
  data() {
    return {
      isTjb: true,
      platform: "tjb",
      skuSpecificationsKey: "skuSpecifications",
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      // skuTableCols: [
      //   {prop: 'skuPrice', attrs: {label: '特价'}, input: {type: 'number'}},
      //   {prop: 'skuMarketPrice', attrs: {label: '划线价'}, input: {type: 'number'}},
      //   {prop: 'skuDeliveryTime', attrs: {label: '相对发货时间'},  input: {type: 'select'} , items: []},
      //   {prop: 'skuOuterId', attrs: {label: '商家编码'}},
      // ],
      self_form: {}, // 与别的平台不同，为了兼容使用规格组件，将skuList初始化到这个对象
      sizeGroupObj: null, // 尺码分组
      propsMap: {}, // 销售属性下的子属性索引
      spIndexMap: {}, // 规格下标索引，防止平台规格顺序调整，编码匹配不上
    }
  },
  computed: {
    isPureType() {
      return this.tjbForm.pureType
    },
    skuTableCols_all() {
      if(this.tjbForm.openSkuDeliveryTime == '1') {
        return [
          {prop: 'skuPrice', attrs: {label: '特价'}, input: {type: 'number'}, previewPrice: true, previewPriceType: 'sales'},
          {prop: 'skuMarketPrice', attrs: {label: '划线价'}, input: {type: 'number'}, previewPrice: true, previewPriceType: 'market'},
          {prop: 'skuStock', attrs: {label: '数量'}, input: {type: 'number'}, disabledFn: (row) => {
            return (this.isPureType || row.stockType === 1)
          }},
          {prop: 'skuDeliveryTime', attrs: {label: '相对发货时间'},  input: {type: 'select'} , items: this.skuTimeOptions},
          {prop: 'skuOuterId', attrs: {label: '商家编码'}},
        ]
      } else {
        return [
          {prop: 'skuPrice', attrs: {label: '特价'}, input: {type: 'number'}, previewPrice: true, previewPriceType: 'sales'},
          {prop: 'skuMarketPrice', attrs: {label: '划线价'}, input: {type: 'number'}, previewPrice: true, previewPriceType: 'market'},
          {prop: 'skuStock', attrs: {label: '数量'}, input: {type: 'number'}, disabledFn: (row) => {
            return (this.isPureType || row.stockType === 1)
          }},
          {prop: 'skuOuterId', attrs: {label: '商家编码'}},
        ]
      }
    },
    skuTimeOptions() {
      let _options =  this.skuDeliveryTimeOptions()[0] || [];
      return _options.map(item => {
        return {
          label: item.displayName,
          value: item.value
        }
      })
    }
  },
  watch: {
    skuTimeOptions:{
      handler(v){
        this.skuTableCols_all.find(item => {
          if(item.prop == 'skuDeliveryTime') {
            item.items = [...v]
          }
        })
      },
      immediate: true,
      deep: true
    },
    props: {
      immediate: true,
      handler(v) {
         let _specifications = [];
         v.dataSource.children.map(item => {
          let isSelect = item.options && item.options.length && !(item.tipRule || []).find(text => /自定义输入/.test(text))
          let _item = {
            name: item.label,
            nameKey: item.name,
            values: [],
          }
          if (isSelect) {
            _item.isSelect = true
            _item.options = item.options
          }
          if (/img/.test(item._oriRules?.valueAttributeRule)) {
            _specifications.unshift(_item);
          } else {
            _specifications.push(_item);
          }
        })
        this.specifications = _specifications;

        this.initPropsMap()
        this.initSpecifications()
        this.initSelfSkuList()
        this.initSizeGroup()
      }
    },
    skuList(v) {
      this.valiSkuOuterId(v)
      if(!this.isPureType) {
        this.handleSkuFieldBlur('skuStock'); // 计算一次总数量
      }
    }
  },
  methods: {
    // 处理skuList表格内的输入控件失焦处理
    handleSkuFieldBlur(field) {
      if (field === 'skuStock') {
        // 数量失焦需要计算总数量给quantity
        let quantity = 0
        this.skuList.forEach(({skuStock}) => {
          quantity += Number(skuStock) || 0
        });
        this.updateTjbForm({
          quantity
        })
      }
    },
    specificationsFieldChanged() {
      this.$emit('fieldChanged')
    },

    // 验证商家编码是否匹配
    valiSkuOuterId(skuList) {
      if(this.isPureType){
        return true
      }
      if (skuList && skuList.length) {
        if (!skuList[0].skuOuterId) {
          this.$message.error('商品明细：商家编码匹配错误，请更换类目或调整规格名数量')
          return false
        }
        return true
      }
      return true
    },
    // 初始化子属性索引
    initPropsMap() {
      const map = {}
      this.props.dataSource.children.forEach(item => {
        map[item.label] = {
          propId: item.name,
          values: item.options,
          children: item.children
        }
      })
      this.propsMap = map
    },
    // 初始化规格信息的数据
    initSpecifications() {
      let final_specifications = [] // 最终生成的规格数据，经过填充和排序
      let canUseSpecificationsIndex = [] // 可使用的详情数据下标

      // 详情数据
      let specifications = JSON.parse(JSON.stringify(this.tjbData.specifications)) || []
      canUseSpecificationsIndex = specifications.map((item, index) => index) // 初始化可用下标
      this.self_form.specifications = JSON.parse(JSON.stringify(specifications))
      // 当前规格信息
      let curr_specifications = JSON.parse(JSON.stringify(this.specifications))

      // 当前规格信息中未与详情数据匹配到的下表索引
      let noMatchSpIndexArr = []
      // 对当前的规格信息遍历
      curr_specifications.forEach((element, elementIndex) => {
        let existSpIndex = specifications.findIndex(item => item.name === element.name)
        // 若详情数据中有相同规格名数据
        if (existSpIndex > -1) {
          canUseSpecificationsIndex.splice(canUseSpecificationsIndex.indexOf(existSpIndex), 1) // 可用下标-1
          this.spIndexMap[existSpIndex] = elementIndex
          let existSp = specifications[existSpIndex]
          let _specification = curr_specifications[elementIndex]
          _specification.values = existSp.values
          if (_specification.isSelect) {
            // 若规格属于下拉框类型
            // 需要清空在options里匹配不到的值
            let _spOptions = _specification.options;
            _specification.values.forEach((v) => {
              if (!_spOptions.find(({displayName}) => v.value === displayName)) {
                v.value = ""
              }
            })
          }
          final_specifications[existSpIndex] = _specification
        } else {
          noMatchSpIndexArr.push(elementIndex)
        }
      });
      // 未匹配的规格 --- 将详情数据剩余的数据按顺序赋给未匹配的
      noMatchSpIndexArr.forEach(index => {
        let _specification = curr_specifications[index]
        if (canUseSpecificationsIndex.length < 1) { // 没有可用下标了
          _specification.values = [{
            checked: true,
            name: "",
            nameKey: "",
            orderId: 999,
            value: "无规格",
            valueKey: ""
          }]
          final_specifications.push(_specification)
        } else {
          // 使用剩余的下标
          let canUseIndex = canUseSpecificationsIndex.shift()
          _specification.values = specifications[canUseIndex].values
          if (_specification.isSelect) {
            // 若规格属于下拉框类型
            // 需要清空在options里匹配不到的值
            let _spOptions = _specification.options;
            _specification.values.forEach((v) => {
              if (!_spOptions.find(({displayName}) => v.value === displayName)) {
                v.value = ""
              }
            })
          }
          final_specifications[canUseIndex] = _specification
          this.spIndexMap[canUseIndex] = index
        } 
      })

      this.specifications = curr_specifications
    },
    // 初始化skuList
    initSelfSkuList() {
      let _skuList = this.tjbData.skuList.map(item => {
        let skus = [...item[this.skuSpecificationsKey]];
        let sortSkus = []
        skus.forEach((item, index) => {
          if (this.spIndexMap[index] === undefined) return;
          sortSkus[index] = skus[this.spIndexMap[index]]
        })
        let _skuid = sortSkus.map(({valueKey}) => valueKey).filter(valueKey => !!valueKey).join('-')

        return {
          ...item,
          _skuid
        }
      })
      this.self_form.skuList = _skuList
    },
    // 初始化尺码分组
    initSizeGroup() {
      // 先找到分组的配置对象
      this.props.dataSource.children.forEach(item => {
        item.children && item.children.forEach(citem => {
          if (citem.name.indexOf('sizeGroup') > -1) {
            this.sizeGroupObj = citem
          }
        })
      })
    },
    // 获取相关数据
    method_getData() {
      let isGroup = 0
      if (!this.valiSkuOuterId(this.skuList)) {
        return false
      }
      if (!this.validateSpecifications()) {
        return false
      } else {
        if(this.isPureType) {
          return [ [], [], {} ,0]
        }
        let [specifications, skuList] = this.getSpecificationData()
        let sizeGroup = {} // 尺码分组后端所需
        if (this.sizeGroupObj) {
          isGroup = 1
          // 若尺码分组存在
          // 获取当前所选的尺码分组
          const sizeGroupVal = this.tjbForm[this.sizeGroupObj.name]
          if (!sizeGroupVal) {
            this.$message.error(`请选择${this.sizeGroupObj.label}`)
            return false;
          } else {
            // 根据所选分组得到其下的所有选项值
            for(const propName in this.propsMap) {
              if (this.propsMap[propName].propId === this.sizeGroupObj.parentName) {
                this.propsMap[propName].values = this.propsMap[propName].children.find(i => /sizeValue$/.test(i.name)).children.find(i => i.name.indexOf(sizeGroupVal) > -1).options
              }
            }
          }
        }

        // 处理specifications中的values值，将propsMap中的value一一对应，若没有对应的，从-2开始自减作为自定义的value
        let _valueId = -2
        specifications.forEach(sp => {
          const options = this.propsMap[sp.name].values || [];
          const propId = this.propsMap[sp.name].propId.replace(/^p-/, '')
          sp.values.forEach(spv => {
            const existOption = options.find(op => (op?.displayName || '') == spv.value)
            if (existOption) {
              spv.propValueId = existOption.value
            } else {
              spv.propValueId = _valueId--
              options.push({displayName: spv.value, value: spv.propValueId})
            }
            spv.propId = propId
          })
        })

        // 有尺码分组的话，生成后段所需尺码分组数据
        if (this.sizeGroupObj) {
          const pid = this.sizeGroupObj.parentName;
          const gvalue = this.tjbForm[this.sizeGroupObj.name]
          const gname = this.sizeGroupObj.options.find(i => i.value == gvalue)?.displayName
          let sizeValue = []
          for (const p in this.propsMap) {
            if (this.propsMap[p].propId === pid) {
              sizeValue = this.propsMap[p].values
            }
          }

          sizeGroup[this.sizeGroupObj.parentName] = {
            valueId: `${pid}-sizeValue`,
            groupId: `${pid}-sizeGroup`,
            groupValue: `${gvalue}`,
            value: `size-${gvalue}`,
            name: gname,
            sizeValue
          }
        }

        // skuList中的skuSpecifications也需要加入propValueId, propId
        skuList.forEach(sku => {
          sku.skuSpecifications.forEach((skuSp, skuSpIndex) => {
            if (skuSpIndex === 0) {
              // 取第一规格的图片赋给sku外层
              sku.imageUrl = skuSp.imageUrl
            }

            const options = this.propsMap[skuSp.name].values || [];
            const existOp = options.find(op => (op?.displayName || '') == skuSp.value)
            if (existOp) {
              skuSp.propValueId = existOp.value
            }
            skuSp.propId = this.propsMap[skuSp.name].propId.replace(/^p-/, '')
          })
        })
        // return false
        return [specifications, skuList, sizeGroup, isGroup]
      }
    },
    changePureType(val) {
      this.updateTjbForm({pureType: val });
      if (!val) {
        this.handleSkuFieldBlur('skuStock'); // 计算一次总数量
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.help-icon {
  margin: -2px 5px 0;
  font-size: 14px;
}
.wrap {
  .wrap-item {
    display: flex;
    .wrap-item_label {
      width: 12%;
      font-size: 12px;
      padding-right: 6px;
      text-align: right;
      flex-shrink: 0;

      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
        box-sizing: border-box;
      }
    }
    .wrap-item_content {
      flex: 1;
      overflow-x: hidden;
    } 
  }
  .wrap-item + .wrap-item {
    margin-top: 20px;
  }
}

</style>